import { all, call, put, takeLatest } from 'redux-saga/effects';
import notification from '../../../services/notification';
import api from '../../../services/api';
import types from '../../types';
import { modal } from '../../../components/Base/Modal';

function* getToken() {
  try {
    const { status, data } = yield call(api.market.tokens.getTokens);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_TOKENS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_TOKENS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

function* postToken({ payload }) {
  try {
    const { status, data } = yield call(api.market.tokens.postTokens, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.POST_TOKEN_SUCCESS, payload: data });
    yield put({ type: types.GET_TOKENS_START });
    modal.close();
  } catch (error) {
    yield put({ type: types.POST_TOKEN_FAILURE });
    if (error?.response?.status === 401) return;
    console.log(error?.response?.data?.errors?.icon);
    if (
      error?.response?.data?.errors?.icon?.includes('the_icon_field_is_required')
    ) {
      notification({ type: 'error', message: 'The icon field is required.' });
      return;
    }

    if (error?.response?.data?.errors?.includes('invalid_token_address')) {
      notification({ type: 'error', message: 'Invalid token contract.' });
      return;
    }

    if (error?.response?.data?.errors?.includes('token_exist')) {
      notification({ type: 'error', message: 'Token exist.' });
      return;
    }

    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

export function* tokens() {
  yield all([
    takeLatest(types.GET_TOKENS_START, getToken),
    takeLatest(types.POST_TOKEN_START, postToken),
  ]);
}
